import { createAsyncThunk } from "@reduxjs/toolkit";
import { patient_prescription } from "../../../networking/urlEndPoints";

import Axios from "../../../networking/interceptor";
import { shrinkImage } from "../../../utils/helper/shrinkImage";

export const UploadPatientPrescripition = createAsyncThunk('UploadPatientPrescripition', async (requestedData, { rejectWithValue }) => {
	try {

		const formData = new FormData();

		formData.append('pharmacy_id', requestedData.pharmacy_id);

		const prescriptions = await Promise.all((requestedData.prescription || []).map(shrinkImage));

		prescriptions.forEach((file, index) => {
			formData.append(`prescription[${index}]`, file, file.name);
		});

		const response = await Axios.post(`${patient_prescription}`, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				"Accept": "multipart/form-data",
			}
		})

		return response.data;

	} catch (error) {
		return rejectWithValue(error.response?.data)
	}
});